import React from "react";
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import MarkInterestPage from "./MarkInterestPage";
import ShareYourGroup from "./ShareYourGroup";

class ModalRouter extends React.Component{
    render(){
        const {page} = this.props;
        return(            
            <div className="dialog-wrapper">
                {page===1 && <Page1 />}
                {page===2 && <Page2 />}
                {page===3 && <Page3 />}
                {page===4 && <ShareYourGroup />}
                {page===5 && <MarkInterestPage />}
            </div>
        )
    }
}

export default ModalRouter;